import { render, staticRenderFns } from "./page_title.vue?vue&type=template&id=0796734e&scoped=true&"
import script from "./page_title.vue?vue&type=script&lang=js&"
export * from "./page_title.vue?vue&type=script&lang=js&"
import style0 from "./page_title.vue?vue&type=style&index=0&id=0796734e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0796734e",
  null
  
)

export default component.exports